import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { Heart } from 'lucide-react';
export const EmotionalCloseSection = () => {
  return <Section bg="bg-cream-light" data-id="element-88">
      <FadeIn data-id="element-89">
        <div className="max-w-3xl mx-auto text-center" data-id="element-90">
          <div className="w-16 h-16 bg-coral/20 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-91">
            <Heart className="w-8 h-8 text-coral" data-id="element-92" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-10 leading-tight text-brown" data-id="element-93">
            Llevas demasiado tiempo sintiéndote así.
          </h2>

          <div className="space-y-3 text-lg md:text-xl text-brown-light leading-relaxed mb-10" data-id="element-94">
            <p data-id="element-95">Demasiadas mañanas pesadas.</p>
            <p data-id="element-96">Demasiados días a medias.</p>
            <p data-id="element-97">
              Demasiadas veces diciéndote que ya va a mejorar — y esperando que
              algo cambie sin hacer nada diferente.
            </p>
          </div>

          <div className="bg-white border border-cream-dark rounded-3xl p-8 md:p-12 mb-10 shadow-sm" data-id="element-98">
            <p className="text-2xl md:text-3xl font-bold text-brown mb-6 leading-snug" data-id="element-99">
              Hoy puedes hacer algo diferente.
            </p>
            <p className="text-lg md:text-xl text-brown-light mb-2" data-id="element-100">
              No tienes que sentirte perfecta para empezar.
            </p>
            <p className="text-lg md:text-xl text-brown-light mb-6" data-id="element-101">
              Solo tienes que dar un paso.
            </p>
            <p className="text-xl md:text-2xl text-gold font-bold italic" data-id="element-102">
              Este es ese paso.
            </p>
          </div>

          <span id="cta-cierre" className="block scroll-mt-24" data-id="element-103"></span>
          <Button className="mx-auto" href="#precio" data-id="element-104">
            ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
          </Button>

          <p className="mt-6 text-sm text-brown-light/70" data-id="element-105">
            Acceso instantáneo · Garantía de 7 días · Pago 100% seguro
          </p>
        </div>
      </FadeIn>
    </Section>;
};